/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { Currency } from './';
import {
    CurrencyFromJSON,
    CurrencyFromJSONTyped,
    CurrencyToJSON,
} from './';
import type { DeliverablePaymentStatus } from './';
import {
    DeliverablePaymentStatusFromJSON,
    DeliverablePaymentStatusFromJSONTyped,
    DeliverablePaymentStatusToJSON,
} from './';
import type { ProjectDeliverablePaymentResource } from './';
import {
    ProjectDeliverablePaymentResourceFromJSON,
    ProjectDeliverablePaymentResourceFromJSONTyped,
    ProjectDeliverablePaymentResourceToJSON,
} from './';

/**
 * 
 * @export
 * @interface FinancingAcceptedPaymentResource
 */
export interface FinancingAcceptedPaymentResource extends ProjectDeliverablePaymentResource {
    /**
     * 
     * @type {Date}
     * @memberof FinancingAcceptedPaymentResource
     */
    expectedPaymentDate: Date;
}

/**
 * Check if a given object implements the FinancingAcceptedPaymentResource interface.
 */
export function instanceOfFinancingAcceptedPaymentResource(value: object): value is FinancingAcceptedPaymentResource {
    if (!('expectedPaymentDate' in value) || value['expectedPaymentDate'] === undefined) return false;
    return true;
}

export function FinancingAcceptedPaymentResourceFromJSON(json: any): FinancingAcceptedPaymentResource {
    return FinancingAcceptedPaymentResourceFromJSONTyped(json, false);
}

export function FinancingAcceptedPaymentResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancingAcceptedPaymentResource {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceFromJSONTyped(json, ignoreDiscriminator),
        'expectedPaymentDate': (new Date(json['expectedPaymentDate'])),
    };
}

export function FinancingAcceptedPaymentResourceToJSON(value?: FinancingAcceptedPaymentResource | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...ProjectDeliverablePaymentResourceToJSON(value, true),
        'expectedPaymentDate': ((value['expectedPaymentDate']).toISOString().substring(0,10)),
    };
}

